// extracted by mini-css-extract-plugin
export default {"anchorHoverEffect":"Specials_anchorHoverEffect__Fa55X"};